import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const PaginationControls = ({ pagination, onPageChange }) => {
  const { page, totalPages, totalCount, pageSize } = pagination;
  const startRecord = totalCount > 0 ? (page - 1) * pageSize + 1 : 0;
  const endRecord = Math.min(page * pageSize, totalCount);
  
  if (totalCount === 0) return null;
  
  return (
    <div className="flex items-center justify-between mt-4 px-2">
      <div className="text-sm text-slate-600">
        Showing {startRecord} to {endRecord} of {totalCount} records
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(1)}
          disabled={page === 1}
        >
          First
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
        >
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <span className="text-sm px-2">
          Page {page} of {totalPages || 1}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
        >
          <ChevronRight className="w-4 h-4" />
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(totalPages)}
          disabled={page >= totalPages}
        >
          Last
        </Button>
      </div>
    </div>
  );
};

export const SortableHeader = ({ field, label, sortBy, sortOrder, onSort, className = "" }) => {
  const isActive = sortBy === field;
  
  return (
    <th 
      className={`cursor-pointer hover:bg-slate-100 select-none px-4 py-2 text-left ${className}`}
      onClick={() => onSort(field)}
    >
      <div className="flex items-center gap-1">
        {label}
        {isActive && (
          <span className="text-xs">
            {sortOrder === 'asc' ? '↑' : '↓'}
          </span>
        )}
      </div>
    </th>
  );
};
